<template>
  <div>
    <v-app class="mt-1">
      <v-main class="custom__bg">
        <v-container class="pt-0 mt-0">
          <v-row>
            <!-- Left Side -->
            <v-col cols="12" md="3" lg="3">
              <v-col cols="12" md="12">
                <v-card class="pa-4 premium-card" style="border-radius: 10px;">
                  <v-card
                    class="pa-0 ma-0 d-flex align-center px-2 hover-scale"
                    flat
                    height="45"
                    style="border-radius: 30px; cursor: pointer"
                    color="#f5f5f5"
                    @click="dialog = true"
                  >
                    <v-btn rounded icon elevation="1" small color="white" style="background-color: #f69227">
                      <v-icon color="white" size="18">mdi-pencil</v-icon>
                    </v-btn>
                    <span class="pl-3 font-weight-medium grey--text text--darken-1" style="font-size: 14px"
                      >Post a question here</span
                    >
                  </v-card>
                </v-card>
              </v-col>
              <LeftMenu />
            </v-col>

            <!-- Center Content (Discussions) -->
            <v-col cols="12" md="6" lg="6">
              <v-card height="" flat color="transparent">
                <div class="pt-2 px-0">
                  <v-card
                    v-for="(item, index) in $root.storeState.discussions"
                    :key="index"
                    class="mb-4 premium-card-elevated animate-fadeInUp"
                    :class="'delay-' + ((index % 5) + 1)"
                  >
                    <v-card-text>
                      <v-row no-gutters class="mb-2">
                        <v-card-subtitle class="ma-0 pa-0">
                          <span style="color: #f69227; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px">
                            {{ item.subject }}
                          </span>
                        </v-card-subtitle>
                        <v-spacer></v-spacer>
                        <v-card-subtitle class="ma-0 pa-0">
                          <span class="grey--text text--darken-1" style="font-size: 12px; font-weight: 500">
                            {{ item.level }}
                          </span>
                        </v-card-subtitle>
                      </v-row>
                      
                      <v-divider class="mb-3"></v-divider>
                      
                      <div class="ml-1 mb-2">
                        <h3 style="font-size: 18px; color: #333; line-height: 1.4">{{ item.title }}</h3>
                      </div>
                      
                      <div class="mb-3 d-flex align-center flex-wrap" v-if="item.tags && item.tags.length">
                        <v-chip
                          v-for="(tag, tagIndex) in item.tags"
                          :key="tagIndex"
                          class="mr-2 mb-2"
                          color="#f0f2f5"
                          text-color="#555"
                          small
                          style="font-weight: 500"
                        >
                          {{ tag }}
                        </v-chip>
                      </div>
                      
                      <div class="mb-3 ml-1">
                        <span style="font-size: 14px; color: #555; line-height: 1.6;">
                          {{ item.content }}
                        </span>
                      </div>
                      
                      <div class="d-flex align-center mb-2" v-if="item.hasImage">
                        <v-btn
                          text
                          color="#f69227"
                          small
                          class="text-capitalize px-1 hover-scale"
                        >
                          <v-icon small left>mdi-image-outline</v-icon>
                          View attached photo
                        </v-btn>
                      </div>

                      <div class="d-flex align-center justify-space-between mt-4">
                        <div class="d-flex align-center">
                          <v-avatar size="32" class="mr-2">
                            <img :src="item.avatar" :alt="item.author" />
                          </v-avatar>
                          <span style="font-size: 13px; font-weight: 600; color: #333;">
                            {{ item.author }}
                          </span>
                        </div>
                        <div class="d-flex align-center grey--text">
                          <span class="mx-2 d-flex align-center" style="font-size: 12px;">
                            <v-icon x-small class="mr-1">mdi-thumb-up-outline</v-icon> {{ item.applauds || 0 }}
                          </span>
                          <span class="mx-2 d-flex align-center" style="font-size: 12px;">
                            <v-icon x-small class="mr-1">mdi-comment-outline</v-icon> {{ item.comments || 0 }}
                          </span>
                        </div>
                      </div>
                      
                      <v-divider class="my-3"></v-divider>
                      
                      <div class="d-flex align-center">
                        <span class="grey--text d-flex align-center" style="font-size: 12px">
                          <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                          {{ item.timeAgo }}
                        </span>
                        <v-spacer></v-spacer>

                        <v-btn icon small class="mx-1 hover-scale" color="grey darken-1">
                          <v-img width="20" height="20" src="../assets/applaud.svg" alt="applaud" style="opacity: 0.7" />
                        </v-btn>
                        
                        <v-btn small icon class="mx-1 hover-scale" color="grey darken-1">
                          <v-icon size="18">fas fa-comment-dots</v-icon>
                        </v-btn>
                        
                        <v-btn small icon class="hover-scale" color="grey darken-1" @click="shareDialog = true">
                          <v-icon size="18">mdi-share-variant</v-icon>
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                  
                  <!-- Empty State -->
                  <v-card class="premium-card text-center pa-10" v-if="$root.storeState.discussions.length === 0">
                    <v-icon size="64" color="grey lighten-2">mdi-forum-outline</v-icon>
                    <h3 class="mt-4 grey--text text--darken-1 font-weight-medium">No discussions yet</h3>
                    <p class="grey--text caption">Start a conversation by posting a question above!</p>
                  </v-card>
                </div>
              </v-card>
            </v-col>

            <!-- Right Side -->
            <v-col cols="12" md="3" lg="3">
              <v-col cols="12" md="12">
                <RightMenu />
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>

    <!-- Ask Question Dialog -->
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card class="premium-card">
        <v-card-title class="headline d-flex align-center py-4 px-5">
          <span style="font-weight: 700; font-size: 20px">Ask a Question</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-form ref="askForm" v-model="valid">
            <v-row>
              <v-col cols="12" sm="6" class="py-1">
                <v-select
                  v-model="newQuestion.subject"
                  :items="subjects"
                  label="Subject"
                  outlined
                  dense
                  rounded
                  color="#f69227"
                  :rules="[v => !!v || 'Subject is required']"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-select
                  v-model="newQuestion.level"
                  :items="levels"
                  label="Academic Level"
                  outlined
                  dense
                  rounded
                  color="#f69227"
                  :rules="[v => !!v || 'Level is required']"
                ></v-select>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-text-field
                  v-model="newQuestion.title"
                  label="Question Title"
                  placeholder="e.g. How to solve quadratic equations?"
                  outlined
                  dense
                  rounded
                  color="#f69227"
                  :rules="[v => !!v || 'Title is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-textarea
                  v-model="newQuestion.content"
                  label="Details"
                  placeholder="Provide more context or specifics about your question..."
                  outlined
                  auto-grow
                  rows="4"
                  rounded
                  color="#f69227"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="py-1">
                 <v-file-input
                  label="Attach Image/Document (Optional)"
                  outlined
                  dense
                  rounded
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  color="#f69227"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-light">
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize px-4" @click="dialog = false" rounded>Cancel</v-btn>
          <v-btn
            color="#f69227"
            class="white--text text-capitalize px-6"
            rounded
            elevation="2"
            :loading="isSubmitting"
            @click="submitQuestion"
          >
            Post Question
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Share Dialog -->
    <v-dialog v-model="shareDialog" max-width="400">
      <v-card class="premium-card pa-2">
        <v-card-title class="headline d-flex align-center pb-2">
          <span style="font-weight: 700; font-size: 18px">Share via</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="shareDialog = false" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4 pb-6 d-flex justify-space-around">
           <v-btn fab color="#1877F2" dark elevation="2" class="hover-scale"><v-icon large>mdi-facebook</v-icon></v-btn>
           <v-btn fab color="#1DA1F2" dark elevation="2" class="hover-scale"><v-icon large>mdi-twitter</v-icon></v-btn>
           <v-btn fab color="#25D366" dark elevation="2" class="hover-scale"><v-icon large>mdi-whatsapp</v-icon></v-btn>
           <v-btn fab color="#0077b5" dark elevation="2" class="hover-scale"><v-icon large>mdi-linkedin</v-icon></v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LeftMenu from "../components/Home_Screen/Left_sideMenu";
import RightMenu from "../components/Home_Screen/Right_sideMenu";

export default {
  components: {
    LeftMenu,
    RightMenu,
  },
  data: () => ({
    dialog: false,
    shareDialog: false,
    valid: false,
    isSubmitting: false,
    subjects: ["Mathematics", "Physics", "Chemistry", "Biology", "Computer Science", "Geography", "English", "Economics"],
    levels: ["Primary", "Junior Secondary", "Senior Secondary", "Tertiary", "Postgraduate"],
    newQuestion: {
      subject: '',
      level: '',
      title: '',
      content: ''
    }
  }),
  methods: {
    submitQuestion() {
      if (this.$refs.askForm.validate()) {
        this.isSubmitting = true;
        
        setTimeout(() => {
          const q = {
            subject: this.newQuestion.subject,
            level: this.newQuestion.level,
            title: this.newQuestion.title,
            content: this.newQuestion.content,
            tags: [this.newQuestion.subject, this.newQuestion.level],
            author: this.$root.storeState.currentUser.name,
            avatar: this.$root.store.getUserAvatar(),
            timeAgo: "Just now",
            applauds: 0,
            comments: 0,
            hasImage: false
          };
          
          this.$root.store.addDiscussion(q);
          
          this.isSubmitting = false;
          this.dialog = false;
          this.$root.showSnackbar("Question posted successfully!", "#43a047", "mdi-check-circle");
          this.$refs.askForm.reset();
        }, 1200);
      }
    }
  }
};
</script>

<style scoped>
.custom__bg {
  background: #f5f5f5;
}
.bg-light {
  background-color: #fafbfc !important;
}
</style>
